import { Button, ButtonProps, CircularProgress } from "@mui/material";
import React, { ReactNode } from "react";

interface Props extends ButtonProps {
	children?: ReactNode;
	isLoading: boolean;
}

export const ButtonWithLoading = ({ children, isLoading, ...props }: Props) => {
	return (
		<Button {...props} disabled={isLoading || props.disabled}>
			{isLoading && <CircularProgress size={"1rem"} />}
			{children}
		</Button>
	);
};
